import {
    Component,
    Input,
    OnInit,
    ViewEncapsulation,
    ViewChild,
    ElementRef,
    AfterViewInit,
    ChangeDetectorRef,
} from '@angular/core';
import { YesNoPipe } from '@fi-app/utilities/fi-pipes/yes-no.pipe';
import { AppTextService } from '@fi-shared/app-text';
import { DocumentSettingModel } from '../../document-setting.model';
import { DocumentModel } from '../../document.model';
import { PublicationSettingModel } from '@fi-shared/models';
import { DocumentService } from '../../document.service';
import { FiSnackBarService } from '@fi-shared/fi-shared-services';
import { FiCommentSettingType, ObjectTypes } from '@fi-shared/types';
import { FiPageCollapsableContentComponent } from '@fi-app/components/fi-page-collapsable-content/fi-page-collapsable-content.component';

@Component({
    selector: 'fi-document-edit-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-document-edit-settings' },
    standalone: false,
})
export class DocumentEditSettingsComponent implements OnInit, AfterViewInit {
    @Input('document') Document: DocumentModel;
    @Input() defaultDocumentSettings;
    @Input() isSettingsExpanded: boolean = false;
    @ViewChild(FiPageCollapsableContentComponent, { static: false })
    pageCollapsableContentComponent: FiPageCollapsableContentComponent;

    allowComments: boolean = false;
    get PublicationSetting() {
        return this.Document.PublicationSetting;
    }

    // disable button by default because there is initially already default settings (got from server or defaults set)
    isSaveSettingAsDefaultDisabled: boolean = true;

    constructor(
        private appTextService: AppTextService,
        private yesNoPipe: YesNoPipe,
        public elementRef: ElementRef,
        private documentService: DocumentService,
        private snackBar: FiSnackBarService,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit() {
        this.updateAllowComments();
    }

    ngAfterViewInit() {
        if (this.isSettingsExpanded) {
            this.pageCollapsableContentComponent.expandContent();
            this.cdr.detectChanges();
        }
    }

    updateAllowComments() {
        this.allowComments = this.Document.DocumentSetting.CommentSettingType === FiCommentSettingType.AllowAllComments;
    }

    getShareText() {
        let result = this.yesNoPipe.transform(this.PublicationSetting.IsShared);
        if (this.PublicationSetting.IsShared) {
            const textId = this.PublicationSetting.PublicationType === 1 ? 'common.continuous' : 'common.time_limited';
            result += ', ' + this.appTextService.get(textId).toLowerCase();
        }
        return result;
    }

    allowCommentsChange($event) {
        this.Document.DocumentSetting.CommentSettingType = $event
            ? FiCommentSettingType.AllowAllComments
            : FiCommentSettingType.NoComments;

        this.settingsChange();
    }

    settingsChange() {
        this.isSaveSettingAsDefaultDisabled = false;
        //this.Document.PublicationSetting.Initialize(this.PublicationSetting);
    }

    saveSettingAsDefault() {
        const setting = DocumentSettingModel.createFromDocument(this.Document.DocumentSetting, this.PublicationSetting),
            settingsUndo = this.defaultDocumentSettings;
        this.documentService.SaveSettingAsDefault(setting).then(() => {
            this.defaultDocumentSettings = setting;
            this.isSaveSettingAsDefaultDisabled = true;
            this.snackBar
                .showSnackbar({
                    textMessage: this.appTextService.get('document.default_settings_updated'),
                    buttonText: this.appTextService.get('common.undo'),
                })
                .onAction()
                .subscribe(() => {
                    this.defaultDocumentSettings = settingsUndo;
                    this.isSaveSettingAsDefaultDisabled = false;
                    this.documentService.SaveSettingAsDefault(settingsUndo);
                });
        });
    }

    protected readonly ObjectTypes = ObjectTypes;
}
